module.exports = __webpack_public_path__ + "img/111.e77ae539.jpg";